import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What should I do immediately after a workplace injury?',
      answer: 'Report your injury to your employer immediately, even if it seems minor. Seek medical attention right away and document everything. Take photos of the accident scene if possible, get witness contact information, and keep copies of all medical records. Contact a workers\' compensation attorney as soon as possible to protect your rights.',
    },
    {
      question: 'How does workers\' compensation work in Ohio?',
      answer: 'Ohio\'s workers\' compensation system is a no-fault insurance program that provides benefits to employees injured on the job. Benefits can include medical coverage, wage replacement, vocational rehabilitation, and permanent disability compensation. Most Ohio employers are required to carry workers\' compensation insurance through the Ohio Bureau of Workers\' Compensation or a private carrier.',
    },
    {
      question: 'What benefits can I receive through workers\' compensation?',
      answer: 'Workers\' compensation benefits in Ohio include full medical coverage for injury-related treatment, temporary total disability payments (wage replacement), permanent partial disability compensation, permanent total disability benefits, vocational rehabilitation services, and death benefits for surviving family members. The specific benefits depend on the nature and severity of your injury.',
    },
    {
      question: 'How do I appeal a denied workers\' compensation claim?',
      answer: 'If your claim is denied, you have the right to appeal. The appeal process involves filing a written appeal with the Ohio Industrial Commission within the specified deadline. You\'ll need to present evidence supporting your claim at a hearing. Having an experienced workers\' compensation attorney significantly increases your chances of a successful appeal.',
    },
    {
      question: 'When should I hire a workers\' compensation lawyer?',
      answer: 'Consider hiring an attorney if your claim is denied, your employer disputes the injury, you\'re receiving inadequate benefits, you have a pre-existing condition, your injury is severe or permanent, you\'re facing retaliation, or you\'re unsure about the claims process. Early legal representation can prevent costly mistakes and maximize your benefits.',
    },
    {
      question: 'How much does a workers\' compensation lawyer cost?',
      answer: 'We work on a contingency fee basis, meaning you pay nothing upfront. Our fee is a percentage of the benefits we recover for you, and we only get paid if we win your case. There are no hourly charges, retainer fees, or out-of-pocket costs. Your initial consultation is completely free.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Common Questions About Workers' Compensation Claims
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to frequently asked questions about Ohio workers' compensation law
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border-l-4 ${
                index % 3 === 0 ? 'bg-gray-50' : 'bg-white'
              } ${openIndex === index ? 'border-teal-600' : 'border-transparent'}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full text-left px-6 py-5 flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">{faq.question}</h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 border-l-4 border-teal-600 ml-6">
                  <p className="text-base text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-gray-600 mb-6">
            Have more questions? We're here to help.
          </p>
          <a
            href="/faq"
            className="inline-flex items-center px-8 py-4 bg-teal-600 text-white rounded-full text-base font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            View All FAQs
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}